/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InactiveCleanupCandidateDTOFromJSON, InactiveCleanupCandidateDTOToJSON, } from './InactiveCleanupCandidateDTO';
/**
 * Check if a given object implements the InactiveCleanupPreviewDTO interface.
 */
export function instanceOfInactiveCleanupPreviewDTO(value) {
    return true;
}
export function InactiveCleanupPreviewDTOFromJSON(json) {
    return InactiveCleanupPreviewDTOFromJSONTyped(json, false);
}
export function InactiveCleanupPreviewDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selectedCount': json['selectedCount'] == null ? undefined : json['selectedCount'],
        'countByReason': json['countByReason'] == null ? undefined : json['countByReason'],
        'marketplaceInventoryCount': json['marketplaceInventoryCount'] == null ? undefined : json['marketplaceInventoryCount'],
        'sharePercent': json['sharePercent'] == null ? undefined : json['sharePercent'],
        'estimatedMinutes': json['estimatedMinutes'] == null ? undefined : json['estimatedMinutes'],
        'sample': json['sample'] == null ? undefined : (json['sample'].map(InactiveCleanupCandidateDTOFromJSON)),
        'activeRunId': json['activeRunId'] == null ? undefined : json['activeRunId'],
    };
}
export function InactiveCleanupPreviewDTOToJSON(json) {
    return InactiveCleanupPreviewDTOToJSONTyped(json, false);
}
export function InactiveCleanupPreviewDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'selectedCount': value['selectedCount'],
        'countByReason': value['countByReason'],
        'marketplaceInventoryCount': value['marketplaceInventoryCount'],
        'sharePercent': value['sharePercent'],
        'estimatedMinutes': value['estimatedMinutes'],
        'sample': value['sample'] == null ? undefined : (value['sample'].map(InactiveCleanupCandidateDTOToJSON)),
        'activeRunId': value['activeRunId'],
    };
}
